<!-- 新闻列表 -->
<template>
    <transition name="el-fade-in-linear">
        <div id="newsList">
            <headerVue></headerVue>
            <div class="container">
                <!-- 右侧 -->
                <div class="right-sider">
                    <div style="display: flex;justify-content: center;margin-top: 10px;"><h3>{{ $route.query.navName }}</h3></div>
                    <div class="right" v-if="newsList.length">
                        <div class="content" v-for="item in newsList" :key="item.id">
                            <img src="../../assets/image/picture/icon_local1.png" />
                            <div class="title" @click="toDetails(item.id)">
                                {{ item.title }}
                            </div>
                            <span class="time hidden-sm-and-down">{{ item.releaseTime }}</span>
                            <span class="time hidden-sm-up">{{
                                item.releaseTime.substr(5, 11)
                            }}</span>
                        </div>
                        <div class="load-more" style="text-align: center">
                            <button v-if="total > 10 && query.pageSize * query.currentPage < total" @click="loadMore"
                                class="btn-more">
                                加载更多
                            </button>
                        </div>
                    </div>
                    <div v-else>
                        <p style="
                            color: #ccc;
                            text-align: center;
                            line-height: 230px;
                            font-size: 28px;
                        ">
                            暂无数据
                        </p>
                    </div>

                    <!-- 分页 -->
                    <el-pagination v-if="this.$route.query.title !== '历届委员会'" class="page" style="margin-top: 16px;float: right;margin-right: 10px;"
                        background layout="total, sizes, prev, pager, next, jumper" :total="total" :page-sizes="[10]"
                        :page-size="query.pageSize" :current-page="query.currentPage" @size-change="changePageSize"
                        @current-change="currentPage">
                    </el-pagination>
                </div>
            </div>

            <footerVue></footerVue>
        </div>
    </transition>
</template>
  
<script>
import headerVue from "../index/header.vue";
import footerVue from "../foot/foot.vue";
import { isMobile } from "@/utils/common.js";
export default {
    name: "selfConstructionList",
    data() {
        return {
            currentNavId: "",
            newsList: [],
            total: 0,
            query: {
                // 当前页数
                currentPage: 1,
                // 一页几条
                pageSize: 10,
            },
            fontSize: "18px"
        };
    },
    created() {
        this.currentNavId = this.$route.query.tm;
        this.getNewsList();
    },
    methods: {
        toDetailWei(_id) {
            this.$router.push(`/newsDetail?tm=${_id}`);
        },
        // 新闻列表跳转至新闻详情
        toDetails(_id) {
            this.$router.push(`/newsDetail?tm=${_id}`);
        },
        // 获取右侧新闻列表
        async getNewsList() {
            let res = await this.$api.nav.getArticle(
                this.currentNavId,
                this.query.currentPage,
                this.query.pageSize,
                1,
                this.$route.query.keyVal,
                this.$route.query.year,
                this.$route.query.name
            );
            // console.log("22222222222222222222", res.data.rows);
            this.newsList = res.data.rows;
            this.total = res.data.total;
        },
        async loadMore() {
            this.query.currentPage++;
            let res = await this.$api.nav.getArticle(
                this.currentNavId,
                this.query.currentPage,
                this.query.pageSize,
                1
            );
            this.newsList = this.newsList.concat(res.data.rows);
            // console.log('loadMore', this.newsList);
        },
        changePageSize(args) {
            this.query.pageSize = args;
            this.getNewsList();
        },
        currentPage(args) {
            this.query.currentPage = args;
            this.getNewsList();
        },
    },
    watch: {
        $route() {
            this.getNewsList();
            this.query.currentPage = 1
        },
    },
    components: {
        headerVue,
        footerVue,
    },
};
</script>
  
<style lang="scss" scoped>
#newsList {
    background-color: #f5f5f5;
}

.container {
    background-color: white;
    margin-top: 0px;
    max-width: 1200px;
    h3 {
        border-radius: 0px 10px 0px 10px;
        background-color: #0b7dda;
        color: white;
        font-size: 22px;
        height: 50px;
        line-height: 50px;
        position: relative;
        padding: 0 12px;
    }
    .right {
        width: 100%;
        overflow-y: scroll;

        .content {
            display: flex;
            align-items: center;
            padding: 17px;
            border-bottom: 1px solid #f0f0f0;
            position: relative;
            background-color: white;

            img {
                margin-right: 10px;
            }

            .title {
                width: 720px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
            }

            span {
                position: absolute;
                right: 0px;
                padding-right: 20px;
                font-size: 14px;
                color: #999999;
            }
        }
    }
}

.content:hover .title {
    color: #3181d1;
    transition: all 0.5s linear;
    cursor: pointer;
}

.el-pagination .el-select .el-input .el-input__inner {
    padding-right: 10px;
}

.el-input__suffix {
    display: none;
}


.load-more {
    display: none;
}

@media screen and (max-width: 768px) {
    .container {
        min-height: 0;
    }
    .page {
        display: none;
    }

    .load-more {
        display: block;
    }

    .btn-more {
        background: #0b7dda;
        padding: 10px 30px;

        border: none;
        color: white;
    }

    .right-sider {
        width: 100%;

        .right {
            margin-left: 0;
            height: auto;
        }
    }

    .container .right .content .title {
        width: auto;
        overflow: hidden;
        display: inline-block;
        text-overflow: ellipsis;
        flex: 1 !important;
    }

    .time {
        position: relative !important;
        margin-left: 10px;
        display: inline-block;
        padding-right: 0 !important;
    }
    @media screen and (max-width: 768px) {
        .right-sider>div:first-child{
            transform: scale(0.7)
        }
    }
}
</style>
  